import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

let Report = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();
  let [sel, setSel] = useState("All");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [ startdate , setStartdate ] = useState()
  let [ enddate , setEnddate ] = useState()

  let [ useruploaddate , setUseruploaddate ] = useState()

  let [ load , setLoad ] = useState(false)
  let [isChecked, setIsChecked] = useState(false);

  // Function to open the popup 
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  // Function to close the popup
  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    Start();
    // Payment();
    // nerPayment();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Payment = async (values) => {
    console.log(values, "values");

    try {
      let token = await localStorage.getItem("token");

      let pp = { token, values: values };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/reward/newreward",
        data: pp,
      })
        .then((dat) => {
          if (dat.data.status === true) {
            // nerPayment();
            // closePopup();
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let nerPayment = async () => {
    const requestData = {
      // Your data to send in the POST request
      someField: "someValue",
      anotherField: "anotherValue",
    };

    try {
      const response = await axios.post(
        Base_url_bbbs + "/reward/reportalldata",
        requestData,
        {
          responseType: "blob", // Important to set the response type to blob for binary data
        }
      );

      // Create a URL for the blob object
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element, set the URL as href, and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "output.xlsx"); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  };

  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  function validateDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      throw new Error("Invalid date format");
    }


    const isSameDay =
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate();
  
    return isSameDay || start < end;
  }

  let Submits = async ( ) =>{

    let hhh = true

    if( useruploaddate === '' || useruploaddate === null || useruploaddate === undefined || useruploaddate === ""){
      hhh =   validateDates(startdate , enddate)
    }
  

 

    console.log(hhh  , 'uiguyguyguy')

    if(hhh === false){
      alert("Start date is greater ")
      return
    }
    setLoad(true)
    const requestData = { 
      enddate , 
      startdate,
      sel,
      useruploaddate,
      isChecked
    };
 

    try {
      const response = await axios.post(
        Base_url + "/admin/reportadmin",
        requestData,
        {
          responseType: "blob", // Important to set the response type to blob for binary data
        }
      );

      // Create a URL for the blob object
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element, set the URL as href, and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "output.xlsx"); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
    setLoad(false)
  }

  const categories = [
    "Fastag",
    "Prepaid",
    "Electricity",
    "LPG Gas",
    "Postpaid",
    "Creditcard",
  ];
  const formik = useFormik({
    initialValues: {
      name: "",
      sub: "",
      exptime: "",
      offertype: "percentage", // default to percentage
      offer: "",
      usertype: "", // default to all
      categorybbps: "",
      rentavaliable: false,
      active: false,
      min: "",
      max: "",
      presentage_avaliable: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      min: Yup.string().required("Min is required"),
      max: Yup.string().required("Max is required"),
      sub: Yup.string().required("Sub is required"),
      exptime: Yup.string().required("Expiration time is required"),
      offertype: Yup.string().required("Offer type is required"),
      offer: Yup.number().required("Offer is required"),
      usertype: Yup.string().required("User type is required"),
      categorybbps: Yup.string().required("Category BBPS is required"),
      presentage_avaliable: Yup.string().required(
        "presentage_avaliable BBPS is required"
      ),
    }),
    onSubmit: (values) => {
      // Handle form submission
      Payment(values);
      console.log("Form Data:", values);
    },
  });

  const inputStyle = {
    margin: "5px 0",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "700",
  };

  const errorStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "5px",
  };

  const containerStyle = {
    display: "flex",
    gap: "20px",
    padding: "20px",
    textAlign: "left",
  };

  const sectionStyle = {
    flex: 1,
  };

  const formSectionStyle = {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "20px",
    marginBottom: "20px",
  };

  let click = async (id) => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/reward/change",
        data: pp,
      })
        .then((dat) => {
          if (dat.data.status === true) {
            nerPayment();
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }} >
          <div className="d-flex justify-content-between">
            <h1 style={{ textAlign: "center" }}>Report</h1>
            <div style={{ padding: 10 }}></div>
          </div>

          <div className="row">
            <div className="col-3">
              <select
                onChange={(e) => {
                  setSel(e.target.value);
                }}
                name="cars"
                id="cars"
              >
                <option value="All" selected={sel === "All" ? true : false}>
                  All
                </option>
                <option
                  value="Failed"
                  selected={sel === "Failed" ? true : false}
                >
                  Failed
                </option>
                <option
                  value="Success"
                  selected={sel === "Success" ? true : false}
                >
                  Success
                </option>
                <option
                  value="Progress"
                  selected={sel === "Progress" ? true : false}
                >
                  Processing
                </option>

                <option
                  value="Refund"
                  selected={sel === "Refund" ? true : false}
                >
                  Refund
                </option>
 

                <option
                  value="SPR"
                  selected={sel === "SPR" ? true : false}
                >
                  Success Processing Refund 
                </option>


              </select>
            </div>
            
            <div className="col-2">
              <p>select start date</p>
              <input onChange={(e)=>{ setStartdate(e.target.value) }} type="date" />
            </div>

            

            <div className="col-2">
              <p>select end date</p>
              <input type="date" onChange={(e)=>{ setEnddate(e.target.value) }} />
            </div>

            <div className="col-2">
              <p>User Uploaded date</p>
              <input type="date" onChange={(e)=>{ setUseruploaddate(e.target.value) }} />
            </div>

            <div className="col-2">
              <p>Phonepe report</p>
              <input 
                type="checkbox" 
                checked={isChecked} 
                onChange={(e) => setIsChecked(e.target.checked)} 
              />
            </div>

            {
              load === false  ?  <div className="col-3">
              <button onClick={()=>{ Submits() }} >Sumbit</button>
            </div> : <p>Loading...</p>
            }

           
          </div>


          

          {isPopupOpen && (
            <div className="popup-overlay">
              <div className="popup-content">
                <div className="d-flex justify-content-between">
                  <h1 style={{ textAlign: "center" }}>New Reward</h1>
                  <div style={{ padding: 10 }}>
                    <button onClick={closePopup}>X</button>
                  </div>
                </div>
                <div style={containerStyle}>
                  <div style={sectionStyle}>
                    <form onSubmit={formik.handleSubmit}>
                      <div>
                        <label htmlFor="name" style={labelStyle}>
                          Name
                        </label>
                        <input
                          id="name"
                          type="text"
                          name="name"
                          value={formik.values.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.name && formik.errors.name && (
                          <span style={errorStyle}>{formik.errors.name}</span>
                        )}
                      </div>
                      <div>
                        <label htmlFor="min" style={labelStyle}>
                          Min
                        </label>
                        <input
                          id="min"
                          type="text"
                          name="min"
                          value={formik.values.min}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.min && formik.errors.min && (
                          <span style={errorStyle}>{formik.errors.min}</span>
                        )}
                      </div>

                      <div>
                        <label htmlFor="usertype" style={labelStyle}>
                          Reward Given Category
                        </label>
                        <select
                          id="usertype"
                          name="usertype"
                          value={formik.values.usertype}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        >
                          {categories.map((category) => (
                            <option key={category} value={category}>
                              {category}
                            </option>
                          ))}
                        </select>
                        {formik.touched.usertype && formik.errors.usertype && (
                          <span style={errorStyle}>
                            {formik.errors.usertype}
                          </span>
                        )}
                      </div>

                      <div style={{ marginTop: 10 }}>
                        <label style={labelStyle}>Rent Available</label>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="rentavaliable"
                              value="true"
                              checked={formik.values.rentavaliable === true}
                              onChange={() =>
                                formik.setFieldValue("rentavaliable", true)
                              }
                              style={{ marginRight: "5px" }}
                            />{" "}
                            True
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="rentavaliable"
                              value="false"
                              checked={formik.values.rentavaliable === false}
                              onChange={() =>
                                formik.setFieldValue("rentavaliable", false)
                              }
                              style={{ marginRight: "5px" }}
                            />{" "}
                            False
                          </label>
                        </div>
                        {formik.touched.rentavaliable &&
                          formik.errors.rentavaliable && (
                            <span style={errorStyle}>
                              {formik.errors.rentavaliable}
                            </span>
                          )}
                      </div>

                      <div style={{ marginTop: 10 }}>
                        <label htmlFor="offertype" style={labelStyle}>
                          Offer Type
                        </label>
                        <select
                          id="offertype"
                          name="offertype"
                          value={formik.values.offertype}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        >
                          <option value="percentage">Percentage</option>
                          <option value="rupees">Rupees</option>
                        </select>
                        {formik.touched.offertype &&
                          formik.errors.offertype && (
                            <span style={errorStyle}>
                              {formik.errors.offertype}
                            </span>
                          )}
                      </div>

                      <div>
                        <label htmlFor="exptime" style={labelStyle}>
                          Expiration Time in days
                        </label>
                        <input
                          id="exptime"
                          type="number"
                          name="exptime"
                          value={formik.values.exptime}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.exptime && formik.errors.exptime && (
                          <span style={errorStyle}>
                            {formik.errors.exptime}
                          </span>
                        )}
                      </div>

                      <div>
                        <label htmlFor="exptime" style={labelStyle}>
                          presentage_avaliable Time in days
                        </label>
                        <input
                          id="presentage_avaliable"
                          type="number"
                          name="presentage_avaliable"
                          value={formik.values.presentage_avaliable}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.presentage_avaliable &&
                          formik.errors.presentage_avaliable && (
                            <span style={errorStyle}>
                              {formik.errors.presentage_avaliable}
                            </span>
                          )}
                      </div>
                    </form>
                  </div>
                  <div style={sectionStyle}>
                    <form onSubmit={formik.handleSubmit}>
                      <div>
                        <label htmlFor="sub" style={labelStyle}>
                          Sub
                        </label>
                        <input
                          id="sub"
                          type="text"
                          name="sub"
                          value={formik.values.sub}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.sub && formik.errors.sub && (
                          <span style={errorStyle}>{formik.errors.sub}</span>
                        )}
                      </div>
                      <div>
                        <label htmlFor="max" style={labelStyle}>
                          Max
                        </label>
                        <input
                          id="max"
                          type="text"
                          name="max"
                          value={formik.values.max}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.max && formik.errors.max && (
                          <span style={errorStyle}>{formik.errors.max}</span>
                        )}
                      </div>

                      <div>
                        <label htmlFor="categorybbps" style={labelStyle}>
                          Reward get Category
                        </label>
                        <select
                          id="categorybbps"
                          name="categorybbps"
                          value={formik.values.categorybbps}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        >
                          {categories.map((category) => (
                            <option key={category} value={category}>
                              {category}
                            </option>
                          ))}
                        </select>
                        {formik.touched.categorybbps &&
                          formik.errors.categorybbps && (
                            <span style={errorStyle}>
                              {formik.errors.categorybbps}
                            </span>
                          )}
                      </div>

                      <div style={{ marginTop: 10 }}>
                        <label style={labelStyle}>Active</label>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="active"
                              value="true"
                              checked={formik.values.active === true}
                              onChange={() =>
                                formik.setFieldValue("active", true)
                              }
                              style={{ marginRight: "5px" }}
                            />{" "}
                            True
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="active"
                              value="false"
                              checked={formik.values.active === false}
                              onChange={() =>
                                formik.setFieldValue("active", false)
                              }
                              style={{ marginRight: "5px" }}
                            />{" "}
                            False
                          </label>
                        </div>
                        {formik.touched.active && formik.errors.active && (
                          <span style={errorStyle}>{formik.errors.active}</span>
                        )}
                      </div>

                      <div style={{ marginTop: 10 }}>
                        <label htmlFor="offer" style={labelStyle}>
                          Offer
                        </label>
                        <input
                          id="offer"
                          type="number"
                          name="offer"
                          value={formik.values.offer}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={inputStyle}
                        />
                        {formik.touched.offer && formik.errors.offer && (
                          <span style={errorStyle}>{formik.errors.offer}</span>
                        )}
                      </div>
                      {
                        load === false ? <button
                        type="submit"
                        style={{
                          padding: "10px 15px",
                          border: "none",
                          borderRadius: "4px",
                          backgroundColor: "#007bff",
                          color: "white",
                          cursor: "pointer",
                          marginTop: 30,
                          width: "100%",
                        }}
                      >
                        Submit
                      </button>   : <p>Loading....</p>
                      }
                      
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Report;
